module.exports = __webpack_public_path__ + "img/score_device_es.e4364585.png";